export enum DefType {
  Card = "Card",
  BattleCard = "BattleCard",
  IntrigueCard = "IntrigueCard",
}
